import { useCallback, useEffect, useState } from 'react';

export interface IUseDropZoneProps {
  onFileDrop(files: FileList): void;
}
export const useDropZone = (props: IUseDropZoneProps) => {
  const { onFileDrop } = props;

  /**
   * Если target содержит дочерние элементы, то событие d&d будет срабатывать для каждого вложенного элемента
   * Поэтому мы отслеживаем общее число событий, при котором значение больше 0 указывают на то, что перетаскивание осуществляется
   * **/
  const [dragEventsCount, setDragEventsCount] = useState(0);

  const handleDragIn = useCallback((event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.types.includes('Files')) {
      setDragEventsCount(count => count + 1);
    }
  }, []);

  const handleDragOut = useCallback((event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();

    setDragEventsCount(count => count - 1);
  }, []);

  const handleDrag = useCallback((event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (event: DragEvent) => {
      event.preventDefault();
      event.stopPropagation();

      setDragEventsCount(0);

      if (event.dataTransfer?.files && event.dataTransfer.files.length) {
        onFileDrop(event.dataTransfer.files);
        event.dataTransfer.clearData();
      }
    },
    [onFileDrop],
  );

  useEffect(() => {
    window.document.addEventListener('dragenter', handleDragIn);
    window.document.addEventListener('dragleave', handleDragOut);
    window.document.addEventListener('dragover', handleDrag);
    window.document.addEventListener('drop', handleDrop);

    return () => {
      window.document.removeEventListener('dragenter', handleDragIn);
      window.document.removeEventListener('dragleave', handleDragOut);
      window.document.removeEventListener('dragover', handleDrag);
      window.document.removeEventListener('drop', handleDrop);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [handleDrop]);

  return {
    showDropZone: dragEventsCount > 0,
  };
};
